import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { ReplacementClaimService } from '@appServices/core-crm/replacement-claim/replacement-claim.service';

@Component({
  selector: 'app-replacement-attachments',
  templateUrl: './replacement-attachments.component.html',
  styleUrl: './replacement-attachments.component.css'
})
export class ReplacementAttachmentsComponent implements OnChanges {
  imageUrls: string[] = [];

  @Input() awaitingEscalation: any;
  @Input() customerDetailCheck: any;
  @Input() kycComponentModeEnum: any;

  @Input() insurancePolicyFlag: boolean;
  @Output() isValidReplacement = new EventEmitter<any>();

  private replacementClaimService = inject(ReplacementClaimService);
  
  constructor(private ref: ChangeDetectorRef) { }

  private loadImages() {
    this.imageUrls = [];
  
    const attachmentIds = this.awaitingEscalation.documentIds;
    
    if (attachmentIds && attachmentIds.length > 0) {
      attachmentIds.forEach(id => {
        this.replacementClaimService
          .getReplacementClaimAttachments(id)
          .subscribe({
            next: (blob) => {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                this.imageUrls.push(reader.result as string);
                this.ref.detectChanges();
              };
            },
            error: (err) => console.error(`Failed to fetch image ${id}`, err)
          });
      });
    }
  }
  
  openBlobInNewTab(blob: string) {
    const win = window.open();
    win.document.write('<img src="' + blob + '">');
  }

  validateAttachments(check) {
    this.isValidReplacement.emit(check);
  }

  downloadImage(imageUrl: string, index: number): void {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = `image_${index + 1}.jpg`;
    link.click();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['awaitingEscalation'] && changes['awaitingEscalation'].currentValue) {
      this.loadImages();
    }
  }
}
